import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { keys } from "ramda"
import { Select } from "antd"
import FigureIconFont, { IconSetEnum, MenuIconSet } from "../../../../uiKit/Icons/figureIcons/FigureIconFont"

type Props = {
    iconColor: Maybe<string>
    value: string
    onChangeCallback: (value: string) => void
}

export const MainMenuIconValue = {
    Menu: "Menu",
    Menu2: "Menu",
    Menu3: "Menu",
    Events: "Events",
    Products: "Products",
    Tickets: "Tickets",
    Services: "Services",
    Services2: "Services",
    Services3: "Services",
    Drinks: "Drinks",
    Drinks2: "Drinks",
}

class MibMainMenuIconSelect extends React.Component<Props> {
    renderSelectOptions = () =>
        keys(MainMenuIconValue).map(mainMenuIcon => (
            <Select.Option key={mainMenuIcon} value={mainMenuIcon}>
                <div
                    style={{
                        position: "relative",
                        top: "-1px",
                        marginRight: "0.5rem",
                        display: "inline-block",
                    }}>
                    <FigureIconFont
                        size={22}
                        className="icon"
                        color={(this.props.iconColor && this.props.iconColor.replace("#", "")) || "AAA"}
                        iconSet={IconSetEnum.MainMenuIcons}
                        icon={MenuIconSet[mainMenuIcon]}
                    />
                </div>
                <b>{MainMenuIconValue[mainMenuIcon]}</b>
            </Select.Option>
        ))

    render() {
        return (
            <Select
                defaultValue={this.props.value}
                value={this.props.value}
                onChange={this.props.onChangeCallback}
                style={{
                    width: "12rem",
                }}>
                {this.renderSelectOptions()}
            </Select>
        )
    }
}

export default MibMainMenuIconSelect
